"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../../theme"));
const useStyles = (0, _styles.makeStyles)({
  wrapPicker: {
    width: '880px',
    paddingRight: '10px',
    marginTop: '-60px',
    [_theme.default.breakpoints.down('lg')]: {
      width: '850px'
    }
  },
  wrapCalendarPicker: {
    width: '880px',
    position: 'relative',
    overflow: 'visible !important',
    [_theme.default.breakpoints.down('lg')]: {
      width: '850px'
    }
  },
  datepickerHeader: {
    padding: '10px 30px 10px 30px'
  },
  datepickerHeaderInputs: {
    width: '50%'
  },
  datepickerHeaderInput: {
    width: '320px'
  },
  datepickerBody: {
    padding: '0 30px 10px 30px'
  },
  datepickerMessages: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    fontFamily: _theme.default.typography.proxima.regular,
    fontSize: '14px',
    lineHeight: '17px',
    marginTop: '30px',
    color: _theme.default.palette.grayScale.dark
  },
  datepickerFooter: {
    padding: '15px 30px 25px 30px',
    [_theme.default.breakpoints.up('md')]: {
      padding: '10px 30px 20px 30px'
    },
    [_theme.default.breakpoints.up('lg')]: {
      padding: '20px 30px 30px 30px'
    }
  },
  datepickerCalendar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  },
  resetButton: {
    padding: '0 !important',
    margin: '0 20px 0 0 !important',
    height: '50px'
  },
  underscore: {
    width: _theme.default.typography.pxToRem(20),
    height: _theme.default.typography.pxToRem(3),
    background: '#061556',
    borderRadius: '10px',
    marginLeft: _theme.default.typography.pxToRem(7.5),
    marginRight: '8px',
    marginTop: '7px'
  }
});
var _default = exports.default = useStyles;